// TODO: Find a way to share this with CFs.
// This is used in CFs so if you make changes here then make sure that CFs repo is updated as well.
export enum LocationAccuracy { High = 'High', Low = 'Low', None = 'None' }

export enum FallAlertConfirmationType { Alert = 'Alert', Contact = 'Contact' }

export enum RangeAndUnit {
    US = '1600 feet',
    OTHERS = '500 meters'
}